import React, { createContext, useContext, useEffect, useState } from "react";
import { getChapterData, getCourses } from "../services/dataService";
import { useAuth } from "./AuthContext"; // Import useAuth

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const { isLoggedIn } = useAuth(); // Get authentication state
  const [basicData, setBasicData] = useState(null);
  const [advancedData, setAdvancedData] = useState(null);
  const [courseCards, setCourseCards] = useState(null);
  const [loading, setLoading] = useState(false); // Default to false
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStaticData = async () => {
      setLoading(true);
      setError(null);
      try {
        const [basicRes, advancedRes, courseRes] = await Promise.all([
          getChapterData("basic"),
          getChapterData("advanced"),
          getCourses(),
        ]);

        if (basicRes.error || advancedRes.error || courseRes.error) {
          throw new Error(basicRes.error || advancedRes.error || courseRes.error);
        }
        
        setBasicData(basicRes.data);
        setAdvancedData(advancedRes.data);
        setCourseCards(courseRes.data);

      } catch (err) {
        setError(err.message);
        // Don't log out here, the interceptor will handle it if it's a 401
      } finally {
        setLoading(false);
      }
    };

    // Only fetch data if the user is logged in
    if (isLoggedIn) {
      fetchStaticData();
    } else {
      // If logged out, clear the data
      setBasicData(null);
      setAdvancedData(null);
      setCourseCards(null);
    }
  }, [isLoggedIn]); // Re-run this effect when isLoggedIn changes

  // Provide a default value for courseCards to prevent destructuring error
  const value = { 
    basicData, 
    advancedData, 
    courseCards: courseCards || [], // Ensure courseCards is always an array
    loading, 
    error 
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);